import { useState } from 'react';

import { CertificateButton } from '../CertificateButton';
import { StepIndicator } from './StepIndicator';
import { StepShots } from './StepShots';
import { StepNav } from './StepNav';

import '../../style/stepper.css';

/**
 * Пошаговая инструкция: скриншот слева, шаг справа (на мобиле — в одну колонку).
 *
 * steps: [{ img, description, button?: { fileName, label } }]
 * heading: заголовок этапа, если на странице несколько блоков подряд
 */
export const Stepper = ({ steps, heading }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const lastIndex = steps.length - 1;
  const step = steps[activeIndex];

  const goTo = (index) => {
    setActiveIndex(Math.min(Math.max(index, 0), lastIndex));
  };

  return (
    <div className="stepper">
      {heading ? <h3 className="stepper-heading">{heading}</h3> : null}

      <div className="stepper-grid">
        <StepShots steps={steps} activeIndex={activeIndex} onChangeStep={goTo} />

        <div className="stepper-body">
          <StepIndicator count={steps.length} activeIndex={activeIndex} onSelect={goTo} />

          <p className="stepper-text" dangerouslySetInnerHTML={{ __html: step.description }} />

          {step.button ? (
            <CertificateButton className="stepper-button" fileName={step.button.fileName}>
              {step.button.label}
            </CertificateButton>
          ) : null}

          <StepNav
            isFirst={activeIndex === 0}
            isLast={activeIndex === lastIndex}
            onBack={() => goTo(activeIndex - 1)}
            onNext={() => goTo(activeIndex === lastIndex ? 0 : activeIndex + 1)}
          />
        </div>
      </div>
    </div>
  );
};
